import apiGenerator from './apiGenerator';

import api from './api/config';

export default apiGenerator(api);
